import axios from "axios";

export default {
  namespaced: true,
  state: {
    billmaterials: [],
    images: [],
    query: null,
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    billmaterialsMessage: ''
  },
  mutations: {
    FINDING_BILLMATERIALS(state, query) {
      state.isReceiving = true;
      state.query = query;
    },
    RECEIVED_BILLMATERIALS(state, payload) {
      state.billmaterials = payload;
      state.isReceiving = false;
    },
    RECEIVING_BILLMATERIALS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVED_BILLMATERIAL(state, payload) {
      state = Object.assign(state, {
        billmaterials: [...state.billmaterials, payload],
        isReceiving: false,
      })
    },
    RECEIVING_BILLMATERIAL(state) {
      state.isReceiving = true;
    },
    UPDATED_BILLMATERIAL(state, payload) {
      let index = state.billmaterials.findIndex(billmaterial => billmaterial._id === payload._id);
      state = Object.assign(state, {
        billmaterials: state.billmaterials.map((billmaterial, i) => {
          if (i === index) {
            return Object.assign({}, billmaterial, payload);
          }
          return billmaterial;
        }),
        isUpdating: false,
        billmaterialsMessage: 'Bill Materials has been updating!',
      })
    },
    UPDATING_BILLMATERIAL(state) {
      state.isUpdating = true;
    },
    DELETED_BILLMATERIAL(state, payload) {
      let indexToDelete = state.billmaterials.findIndex(billmaterial => billmaterial._id === payload._id);
      let billmaterials = [...state.billmaterials];
      billmaterials.splice(indexToDelete, 1);
      state = Object.assign(state, {
        billmaterials: [...billmaterials],
        isDeleting: false,
        idToDelete: null,
        billmaterialsMessage: 'Bill Material has been Deleted!',
      });
    },
    DELETING_BILLMATERIAL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteBillMaterialRequest({dispatch}, payload) {
      dispatch("deletingBillMaterial", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/billmaterial/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteBillMaterial", response.data);
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteBillMaterialTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/delete/billmaterialtransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertBillMaterialRequest({dispatch}, payload) {
      dispatch("receivingBillMaterials");
      var token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.accountxc.com:3100/insert/billmaterial';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      console.log('Insert', data)
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveBillMaterial", response.data);
      return response.data;
    },
    async insertBillMaterialTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/insert/billmaterialtransaction/" + payload.billmaterialid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getBillMaterialsRequest({dispatch}) {
      dispatch("receivingBillMaterials");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/billmaterials';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(response => {
        dispatch("receiveBillMaterials", response.data);
      })
    },
    async getBillMaterialQueryRequest({dispatch}, payload) {
      try{
        dispatch("findingBillMaterials", payload);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/billmaterials/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveBillMaterials", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateBillMaterialRequest({dispatch}, payload) {
      dispatch("updatingBillMaterial");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/billmaterial/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateBillMaterial", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    updateBillMaterialTrade({dispatch}, payload) {
      dispatch("updatingBillMaterial");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/billmaterial/trade/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put",url: url,headers: headers,data: payload})
      .then((response)=> {
        dispatch("updateBillMaterial", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateBillMaterialTransaction({dispatch}, payload) {
      try{
        dispatch("receivingBillMaterial");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/billmaterialtransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingBillMaterial", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    findingBillMaterials({commit}, payload) {
      commit("FINDING_BILLMATERIALS", payload.query)
    },
    receiveBillMaterials({commit}, payload) {
      commit("RECEIVED_BILLMATERIALS", payload)
    },
    receivingBillMaterials({commit}) {
      commit("RECEIVING_BILLMATERIALS")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receiveBillMaterial({commit}, payload) {
      commit("RECEIVED_BILLMATERIAL", payload)
    },
    receivingBillMaterial({commit}) {
      commit("RECEIVING_BILLMATERIAL")
    },
    updateBillMaterial({commit}, payload) {
      commit("UPDATED_BILLMATERIAL", payload)
    },
    updatingBillMaterial({commit}) {
      commit("UPDATING_BILLMATERIAL")
    },
    deleteBillMaterial({commit}, payload) {
      commit("DELETED_BILLMATERIAL", payload)
    },
    deletingBillMaterial({commit}, payload) {
      commit("DELETING_BILLMATERIAL", payload)
    }
  },
};
